module.exports = __webpack_public_path__ + "resources/275d6b6a5e57f4596aaf5fab085677f3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/location.png
// module id = 213
// module chunks = 0